import { auth } from '../firebase';
import { MYKYC_API_BASE } from '../config/api';
import { categoryLabels } from '../utils/clientDocumentIntake';

export function intakeAttachmentContext(document, target, dropContext) {
  const category = document.category;
  const label = categoryLabels[category];
  const partyId = target.partyIds[0];
  const docKey = { id_document: 'id', trade_licence: 'reg', proof_of_address: 'poa' }[category];
  // A drop location is a hint, never evidence that the file belongs to its party
  // or satisfies that requirement. Route from the confirmed holder and type.
  const requirementKey = docKey ? `party:${partyId}:${docKey}` : `additional:${category}:${target.id}`;
  const cardId = `party_${partyId.replace(/[^a-zA-Z0-9_-]/g,'_')}`;
  const meta = { kind: target.type, partyId, sourcePartyIds: target.partyIds, partyName: target.name, partyRole: target.role,
    nationalityIso2: target.type === 'individual' ? target.customer.nationalityOrIncorporationCountry || '' : '',
    incorporationIso2: target.type === 'entity' ? target.customer.nationalityOrIncorporationCountry || '' : '', domicileIso2: target.customer.country || '', partyAddress: target.customer.address || '' };
  return { requirementKey, requirementText: label, cardId, cardTitle: target.name,
    cardSnapshot: { id: cardId, title: target.name, section: docKey ? 'Identification documents' : 'Other documents', description: label,
      meta, options: [{ key: requirementKey, label, acceptedLabels: [label] }] } };
}
export async function staffIntakeRequest(action, payload, signal) {
  const token = await auth.currentUser?.getIdToken();
  if (!token) throw new Error('Sign in to save this document.');
  const response = await fetch(`${MYKYC_API_BASE}/myKyc/staff/doc-upload/attach/${action}`, { method: 'POST', signal,
    headers: { 'Content-Type': 'application/json', Authorization: `Bearer ${token}` }, body: JSON.stringify(payload) });
  const result = await response.json();
  if (!response.ok || !result.ok) throw new Error('The document could not be saved. Please try again.');
  return result;
}
